export default {
  title: '{{plan}} este activ',
  plan: 'Plan: {{plan}}',
  free_until: 'Gratuit până la {{date}}',
  continue: 'Continuă',
};
